import React from "react";
import SummarySection from "@/components/resume-builder/SummarySection";
import SkillsSection from "@/components/resume-builder/SkillsSection";
import ExperienceSection from "@/components/resume-builder/ExperienceSection";
import EducationSection from "@/components/resume-builder/EducationSection";
import ProjectsSection from "@/components/resume-builder/ProjectsSection";
import InternshipsSection from "@/components/resume-builder/InternshipsSection";
import CertificationsSection from "@/components/resume-builder/CertificationsSection";
import LanguagesSection from "@/components/resume-builder/LanguagesSection";
import WebsitesSection from "@/components/resume-builder/WebsitesSection";
import TagListSection from "@/components/resume-builder/TagListSection";
import CustomSectionsSection from "@/components/resume-builder/CustomSectionsSection";

// Canonical order — MUST match backend's DEFAULT_SECTION_ORDER in resume_builder_routes.py
// (also the order the PDF/DOCX export and the Modern/Classic/Minimal live-preview templates
// use by default). Drag-and-drop reordering just permutes this array per-resume.
export const DEFAULT_SECTION_ORDER = [
  "summary", "skills", "experience", "education", "projects", "internships",
  "certifications", "languages", "websites", "hobbies", "extracurricular", "custom_sections",
];

// `extra: true` sections only render once the learner has revealed them via "Add sections".
export const SECTION_REGISTRY = {
  summary: { label: "Summary", render: (p) => <SummarySection {...p} /> },
  skills: { label: "Skills", render: (p) => <SkillsSection {...p} /> },
  experience: { label: "Experience", render: (p) => <ExperienceSection {...p} /> },
  education: { label: "Education", render: (p) => <EducationSection {...p} /> },
  projects: { label: "Projects", render: (p) => <ProjectsSection {...p} /> },
  internships: { label: "Internships", render: (p) => <InternshipsSection {...p} /> },
  certifications: { label: "Certifications", render: (p) => <CertificationsSection {...p} /> },
  languages: { label: "Languages", render: (p) => <LanguagesSection {...p} /> },
  websites: { label: "Websites", extra: true, render: (p) => <WebsitesSection {...p} /> },
  hobbies: {
    label: "Hobbies", extra: true,
    render: (p) => <TagListSection {...p} field="hobbies" label="Hobbies" placeholder="Type a hobby and press Enter" testPrefix="hobbies" />,
  },
  extracurricular: {
    label: "Extra-Curricular", extra: true,
    render: (p) => <TagListSection {...p} field="extracurricular" label="Extra-Curricular Activities" placeholder="Type an activity and press Enter" testPrefix="extracurricular" />,
  },
  custom_sections: { label: "Custom Sections", render: (p) => <CustomSectionsSection {...p} /> },
};
